module.exports = __webpack_public_path__ + "static/img/GuitarPlayer2020 (1).e57ccd7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newSpark/GuitarPlayer2020 (1).png
// module id = quuW
// module chunks = 13